import { render } from "./CreateTimeSlotGroupClass.vue?vue&type=template&id=750bfdd7&scoped=true"
import script from "./CreateTimeSlotGroupClass.vue?vue&type=script&lang=js"
export * from "./CreateTimeSlotGroupClass.vue?vue&type=script&lang=js"

import "./CreateTimeSlotGroupClass.vue?vue&type=style&index=0&id=750bfdd7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750bfdd7"]])

export default __exports__